import * as React from "react";
const IconPieChart = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M37.4 2.2C21-.7 5.2 10.2 2.3 26.6c-1.5 7.9.3 16 4.9 22.6 4.6 6.7 11.5 11.1 19.4 12.6 1.8.3 3.6.5 5.4.5 14.3 0 27.1-10.3 29.8-24.9 2.9-16.4-8-32.2-24.4-35.2m19.9 34.4c-.1.8-.3 1.6-.5 2.3l-22.6-8.5v-24c.8.1 1.6.2 2.3.3 14 2.5 23.3 15.9 20.8 29.9M29.7 6.4v23.4H6.4l.3-2.4c2.1-11.7 11.8-20.1 23-21m-2.3 50.9c-6.8-1.2-12.6-5-16.5-10.7-2.6-3.7-4.1-8-4.5-12.4h25.2l23.6 8.9C50.3 53.3 39 59.5 27.4 57.3" />
  </svg>
);
export default IconPieChart;
